export const GoogleMapApiConfig = 'AIzaSyDUUmXgTsRTddqwGAgQcaTE72U0wVhHU8k';